import React, { FC } from "react";

const ChevronsRight: FC = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.85082 17.7709L4.56634 19.4864C4.7616 19.6816 5.07818 19.6816 5.27344 19.4864L12.4863 12.2735C12.6816 12.0782 12.6816 11.7616 12.4863 11.5664L5.27344 4.35348C5.07818 4.15822 4.7621 4.15772 4.56684 4.35298L2.84557 6.07425C2.65333 6.26649 2.65011 6.5769 2.83807 6.77331L7.83986 11.9999L2.8482 17.0664C2.65542 17.2621 2.65659 17.5766 2.85082 17.7709ZM9.8509 17.7709L11.5664 19.4864C11.7617 19.6817 12.0783 19.6817 12.2735 19.4864L19.4864 12.2735C19.6817 12.0783 19.6817 11.7617 19.4864 11.5664L12.2735 4.35354C12.0783 4.15827 11.7622 4.15777 11.5669 4.35304L9.84564 6.0743C9.65341 6.26654 9.65018 6.57695 9.83815 6.77337L14.8399 12L9.84828 17.0664C9.65549 17.2621 9.65666 17.5767 9.8509 17.7709Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(ChevronsRight);
